import { ArrayOps } from '../lift';
/**
 * Takes the last 'count' items from this Array.
 */
export function takeRight(count) {
    var arr = this.value();
    return new ArrayOps((arr.length < count)
        ? arr.slice(0)
        : arr.slice(arr.length - count));
}
ArrayOps.prototype.takeRight = takeRight;
